export const visualIndicationChip = {
  height: "10px",
  width: "10px",
  color: "white",
};
